import { inject, Injectable, Type } from '@angular/core';
import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';
import { IFpCorrelationTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-tab-connect-service';
import { FpCorrelationCommentsComponent } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-comments/components/fp-correlation-comments/fp-correlation-comments.component';
import { FpCorrelationCommentsMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-comments/components/fp-correlation-comments-minimized/fp-correlation-comments-minimized.component';
import { FpCorrelationCommentsActionType } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-comments/services/fp-correlation-comments/fp-correlation-comments.actions';
import { FpCorrelationCommentsStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-comments/services/fp-correlation-comments/fp-correlation-comments.store';
import { Observable } from 'rxjs';

@Injectable()
export class FpCorrelationCommentsConnectService implements IFpCorrelationTabConnectService {
  protected tabStore = inject(FpCorrelationCommentsStore);
  public currentTab = FpCorrelationTabs.Comments;

  public component: Type<unknown> = FpCorrelationCommentsComponent;
  public minimizedComponent: Type<unknown> = FpCorrelationCommentsMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isActive(tab: FpCorrelationTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: IFpCorrelationData) {
    this.tabStore.dispatch({
      type: FpCorrelationCommentsActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: IFpCorrelationData) {
    this.tabStore.dispatch({
      type: FpCorrelationCommentsActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
